import { useEffect } from 'react'
import { setCurrentOrgId } from './orgModel'
import { createOrganizationApiV1OrganizationsPost } from '@/common/api/client/sdk.gen'
import type {
    OrganizationCreate,
    OrganizationResponse,
    OrganizationWithUserRoleResponse,
} from '@/common/api/client/types.gen'
import { useQueryClient } from '@tanstack/react-query'
import { useFormMutation } from '@/common/hooks/useFormMutation'

export const useOrgAddForm = () => {
    const queryClient = useQueryClient()
    const { form, handleSubmit, onSubmit, register, isLoading, isError, isSuccess, error } = useFormMutation<
        OrganizationCreate,
        OrganizationResponse,
        {
            detail?: string
            field_errors?: Record<keyof OrganizationCreate, string>
        }
    >({
        mutationFn: data => createOrganizationApiV1OrganizationsPost({ body: data }).then(res => res.data!),
        toastOptions: {
            successMessage: 'Организация создана',
        },
        onSuccess: createdOrg => {
            setCurrentOrgId(createdOrg.id)
            queryClient.setQueryData(['my_orgs'], (old: OrganizationWithUserRoleResponse[] = []) => [
                ...old,
                createdOrg as OrganizationWithUserRoleResponse,
            ])
            queryClient.setQueryData(['current_org', createdOrg.id], createdOrg)
            queryClient.invalidateQueries({ queryKey: ['org_members'] })
            return createdOrg
        },
    })

    useEffect(() => {
        form.reset({
            name: '',
            description: '',
        })
    }, [form])

    return { form, handleSubmit, onSubmit, register, isPending: isLoading, isError, isSuccess, error }
}
